import { useState } from "react";
import { APIHandlerStudioLicense } from "hooks/api-handler-studio-license";
import { useQueryClient } from "@tanstack/react-query";

export function UseLazyApiCallStudioLicense({ url, method, paramsData }: any) {
  const [data, setData] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<any>();

  const queryClient = useQueryClient();

  async function getData(props: any) {
    const localData = props?.params || paramsData;
    const localUrl = props?.url || url;
    const silent = props?.silent ?? false;
    const force = props?.force || false;

    let apiResponseInitial = null;

    try {
      !silent && setIsLoading(true);
      const queryKey = ["studio-license", method, localUrl, localData];

      const data = force
        ? await queryClient.fetchQuery({
            queryKey,
            queryFn: () =>
              APIHandlerStudioLicense({
                method,
                url: localUrl,
                data: localData,
              }),
            staleTime: 0,
          })
        : await queryClient.fetchQuery({
            queryKey,
            queryFn: () =>
              APIHandlerStudioLicense({
                method,
                url: localUrl,
                data: localData,
              }),
            staleTime: 60 * 1000, // Cache for 1 minute
          });
      // const data: any = await APIHandlerStudioLicense({
      //   method,
      //   url: localUrl,
      //   data: localData,
      // });

      setData(data);
      apiResponseInitial = data;
    } catch (error) {
      setError(error);
    } finally {
      setIsLoading(false);
    }
    return apiResponseInitial;
  }

  return [getData, { data, isLoading, error }];
}
